// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.revenue-page {
  min-height: min(600px, 65vh);
  padding-top: 20px;
}
.revenue-page .chartr-wrapper {
  width: 100vw;
}
.revenue-page .calender-wrapper {
  min-height: 80px;
}
.revenue-page .loading-section {
  min-height: 50px;
}
.revenue-page .organization-section {
  min-height: 40px;
  margin-bottom: 20px;
}
.revenue-page .organization-section_title {
  text-align: center;
  font-weight: 500;
  width: 100%;
  font-size: 16px;
  padding: 12px 0;
}
.revenue-page .charts-section {
  width: 100%;
  min-width: 600px;
  height: 600px;
  min-height: 600px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/charts/RevenueWrapper.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,iBAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,gBAAA;EACA,mBAAA;AAFJ;AAII;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAFN;AAME;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AAJJ","sourcesContent":[".revenue-page {\n  min-height: min(600px, 65vh);\n  padding-top: 20px;\n\n  .chartr-wrapper {\n    width: 100vw;\n  }\n\n  .calender-wrapper {\n    min-height: 80px;\n  }\n\n  .loading-section {\n    min-height: 50px;\n  }\n\n  .organization-section {\n    min-height: 40px;\n    margin-bottom: 20px;\n\n    &_title {\n      text-align: center;\n      font-weight: 500;\n      width: 100%;\n      font-size: 16px;\n      padding: 12px 0;\n    }\n  }\n\n  .charts-section {\n    width: 100%;\n    min-width: 600px;\n    height: 600px;\n    min-height: 600px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
